export const Panel = ({ title, action, children, className = "", testId }) => (
  <section className={`bg-white rounded-md border border-stone-200 ${className}`} data-testid={testId}>
    {(title || action) && (
      <div className="flex items-center justify-between gap-3 px-4 py-3 border-b border-stone-200">
        <h2 className="font-sans text-sm font-bold text-[#1A2E1C] uppercase tracking-wide">{title}</h2>
        {action}
      </div>
    )}
    <div className="p-4">{children}</div>
  </section>
);

export const PageTitle = ({ children, sub, action }) => (
  <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
    <div>
      <h1 className="font-display text-3xl sm:text-4xl text-primary font-semibold">{children}</h1>
      {sub && <p className="text-sm text-stone-500">{sub}</p>}
    </div>
    {action}
  </div>
);

export const Btn = ({ variant = "primary", className = "", ...p }) => {
  const v = {
    primary: "bg-primary text-white hover:bg-primary/90",
    outline: "border border-stone-300 bg-white text-primary hover:bg-stone-50",
    danger: "bg-accent text-white hover:bg-accent/90",
    ghost: "text-primary hover:bg-stone-100",
  }[variant];
  return <button {...p} className={`h-9 px-3 rounded-md text-sm font-semibold disabled:opacity-40 transition-colors ${v} ${className}`} />;
};

const TONES = {
  green: "bg-secondary/15 text-[#4f5d27]", orange: "bg-accent/10 text-accent", grey: "bg-stone-200 text-stone-600",
  blue: "bg-sky-100 text-sky-800", dark: "bg-primary text-white",
};
export const Pill = ({ tone = "grey", children, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center rounded px-2 py-0.5 text-[11px] font-bold whitespace-nowrap ${TONES[tone]}`}>{children}</span>
);

export const statusTone = (s) => ({ placed: "orange", confirmed: "blue", packed: "blue", out_for_delivery: "dark", delivered: "green", cancelled: "grey" }[s]);
export const payTone = (s) => ({ verified: "green", paid: "green", proof_submitted: "orange", awaiting_proof: "orange", rejected: "grey", due_on_delivery: "blue" }[s]);
